/**
 * Non-exhaustive list of key values for use in keyboard event handlers
 */
const Key = {
  Enter: 'Enter',
  Space: ' '
}

export default Key
